import processCardEvents from "./process_card_events";
import auditEventTracker from "./audit_event_tracker";
import processLastCardEvents from "./process_last_card_events";
import processChangeGameChoices from "./process_change_game_choices";

export const rptEventsAudit = (eventsTracker, rptParameters ) => {
    let playerName = rptParameters.player;
    var rptArr = [];
    let firstRecord = true;
    for (let i=0; i<eventsTracker.length; i++){
        let calcEventArr = [];
        let calcEventObj = {};
        switch (eventsTracker[i].eventType){
            case "BadgeEarned":
            case "ExtraCredit":
            case "GameActivity":
            case "RegularCard":
            case "TaxChange":
                calcEventObj = processCardEvents(eventsTracker[i].eventType, eventsTracker[i].gameData, 
                    eventsTracker[i].event);
                calcEventArr.push(calcEventObj);
                break;
            case "LastCard":
                calcEventArr = processLastCardEvents(eventsTracker[i].gameData, eventsTracker[i].event);
                break;
            case "ChangeGameChoices":
            case "UnlockedFeatures":
                calcEventArr = processChangeGameChoices(eventsTracker[i].eventType, 
                        eventsTracker[i].gameData, eventsTracker[i].event);
                break;
            default: 
                break;
        }
        if (firstRecord === true){
            firstRecord = false;
            let eventAuditString = {player: "Player", eventNbr: "Event Nbr", process: "Process", 
               subProcess: "Sub-Process",
               errorFld: "Error Field", calculatedValue: "Calculated Value", 
               gameValue: "Game Value" };
            rptArr.push(eventAuditString);
        
        }
        const nextIndx = i + 1;
        if (nextIndx < eventsTracker.length){
            for (let j=0; j<calcEventArr.length; j++){
                const errorRptArr = auditEventTracker(playerName, eventsTracker[i].eventNbr, 
                    eventsTracker[i].eventType, calcEventArr[j], 
                    eventsTracker[nextIndx].gameData);
           
                for (let k=0; k<errorRptArr.length; k++){
                    rptArr.push(errorRptArr[k]);
                }
            }
        }
       
    }
     
    return rptArr;
} 

export default rptEventsAudit;

